module.exports = __webpack_public_path__ + "static/media/ET078 new.3cb8eec9.jpg";